import { Slider } from "../../atoms/Slider/Slider"

type SliderWithLabelProps = {
  label: string;
  value: number[];
  disabled: boolean;
  onChange: (value: number[]) => void;
}

const SliderWithLabel = ({ label, value, disabled, onChange }: SliderWithLabelProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-2w">
      <span className='text-body1'>{label} : {value[0]}</span>
      <Slider disabled={disabled} value={value} onValueChange={onChange} className="w-full" />
    </div>
  )
}

export default SliderWithLabel;